!function(){"use strict";angular.module("ui.scroll.jqlite",[])}();